<!-- Messages toggle -->
<button
    mat-icon-button
    (click)="openPanel()"
    #messagesOrigin>
    <ng-container *ngIf="unreadCount > 0">
        <span class="absolute top-0 right-0 left-0 flex items-center justify-center h-3 z-10">
            <span class="flex items-center justify-center flex-shrink-0 min-w-4 h-4 px-1 ml-4 mt-2.5 rounded-full bg-indigo-600 text-indigo-50 text-xs font-medium">
                {{unreadCount}}
            </span>
        </span>
    </ng-container>
    <mat-icon [svgIcon]="'heroicons_outline:chat-bubble-left-ellipsis'"></mat-icon>
</button>

<!-- Messages panel -->
<ng-template #messagesPanel>

    <div class="fixed inset-0 sm:static sm:inset-auto flex flex-col message-tab-min-width w-100 sm:rounded-2xl overflow-hidden shadow-lg ring-1 ring-opacity-50 ring-gray-200 right-10">

        <!-- Header -->
        <div class="flex flex-shrink-0 items-center py-1 pr-4 pl-6 bg-card text-gray-700 border-b-2 border-gray-200">
            <div class="sm:hidden -ml-1 mr-3">
                <button
                    mat-icon-button
                    (click)="closePanel()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'heroicons_solid:x'"></mat-icon>
                </button>
            </div>
            <div class="text-2xl font-semibold leading-10">{{ this._utilityService.getLocaleValue("text.messages", 'Messages')}}</div>
            <div class="ml-auto">
                <button
                    mat-icon-button
                    [disabled]="unreadCount === 0"
                    [matTooltip]="('text.mark_all_as_read' | translate)"
                    (click)="markAsRead()">
                    <mat-icon
                        class="icon-size-5 text-current"
                        [svgIcon]="'mat_solid:checklist'"></mat-icon>
                </button>
            </div>
        </div>

        <!-- Content -->
        <div class="relative flex items-center flex-col flex-auto max-h-80vh divide-y overflow-y-auto bg-card" [ngClass]="{'min-h-120 justify-center' : allMessages?.length === 0 || showLoader}">
            <!-- Messages -->
            <ng-container *ngFor="let message of allMessages | slice:0:messageDisplayCount; trackBy: trackByFn; let i = index">
                <a routerLink="/jobs/{{message.job?.job_uid}}/details" (click)="markAsRead(message.job.job_uid)" id="message_{{i}}"
                    class="flex group w-full hover:bg-gray-50 dark:hover:bg-black dark:hover:bg-opacity-5 cursor-pointer">
                    <!-- Message with a link -->
                    <ng-container>
                        <!-- Normal links -->
                        <ng-container *ngIf="!message.useRouter">
                            <div class="flex items-center flex-auto py-3 pl-6 cursor-pointer">
                                <ng-container *ngTemplateOutlet="messageContent"></ng-container>
                        </div>
                        </ng-container>
                    </ng-container>
                    <!-- Actions -->
                    <div class="relative flex flex-col my-5 mr-6 ml-2" *ngIf="message?.unread_count">
                        <!-- Indicator -->
                        <span class="inline-flex items-center rounded-full font-semibold max-w-48 break-all
                        px-3 py-4 h-5 text-base truncate text-red-600 bg-red-100"> {{message?.unread_count}} </span>
                    </div>
                </a>

                <!-- Message content template -->
                <ng-template #messageContent>
                    <!-- Icon -->
                    <ng-container >
                        <div class="flex relative flex-shrink-0 items-center justify-center w-12 h-12 mr-4">
                            <div
                                style="width: 8px; height: 8px;"
                                class="absolute bottom-1 right-1 flex-0 -ml-0.5 rounded-full ring-2 ring-bg-card dark:ring-gray-900 bg-primary dark:bg-primary-500 text-on-primary">
                            </div>
                            <div  *ngIf="!_utilityService.hasValidProfilePicture(message?.recent_message?.sender?.profile_picture)"
                                class="flex items-center justify-center h-12 w-12 overflow-hidden rounded-md uppercase text-3xl font-secondary leading-none bg-gray-200 text-gray-600 dark:bg-gray-700 dark:text-gray-200 flex-shrink-0">
                                {{message?.recent_message?.sender?.first_name.slice(0,1)}}
                            </div>
                            <div class="flex-shrink-0 h-12 w-12" *ngIf="_utilityService.hasValidProfilePicture(message?.recent_message?.sender?.profile_picture)">
                                <img class="h-12 w-12 rounded-md bg-gray-400 flex items-center justify-center ring-8 ring-white" 
                                src="{{message?.recent_message?.sender['profile_picture']}}" alt="">
                            </div>
                        </div>
                    </ng-container>
                    <!-- Title, description & time -->
                    <div class="flex flex-col flex-auto">
                        <ng-container *ngIf="message?.recent_message?.sender?.first_name">
                            <div class="font-semibold text-base line-clamp-1">
                                {{message?.recent_message?.sender?.first_name}} - <span class="text-secondary">{{message.job?.job_title}}</span>
                            </div>
                        </ng-container>
                        <ng-container *ngIf="message?.recent_message?.message">
                            <div
                                class="line-clamp-2 text-base break-all">{{message?.recent_message?.message}}</div>
                        </ng-container>
                        <div class="mt-2 text-sm leading-none text-secondary">
                            {{message?.recent_message?.sent_at | dateAgo}}
                        </div>
                    </div>
                </ng-template>
            </ng-container>

            <!-- No messages -->
            <ng-container *ngIf="!allMessages || allMessages?.length===0">
                <div class="flex flex-col flex-auto items-center md:justify-center sm:justify-start py-12 px-8">
                    <div class="flex flex-0 items-center justify-center w-14 h-14 rounded-full bg-primary-100">
                        <mat-icon
                            class="text-primary-500-700"
                            [svgIcon]="'heroicons_outline:inbox'"></mat-icon>
                    </div>
                    <div class="mt-5 text-2xl font-semibold tracking-tight">{{_utilityService.getLocaleValue('message.no_messages', 'No Messages')}}</div>
                    <div class="w-full max-w-60 mt-1 text-md text-center text-secondary">{{_utilityService.getLocaleValue('message.when_you_have_messages_they_will_appear_here', 'When you have messages, they will appear here.')}}</div>
                </div>
            </ng-container>
            <div class="text-center border-none mb-3 mt-3" *ngIf="allMessages?.length > messageDisplayCount"><a class="cursor-pointer" (click)="updateMessageDisplayCount()">{{_utilityService.getLocaleValue("text.view_more", "View More")}}</a></div>
        </div>
    </div>
</ng-template>
